import styled from 'styled-components'
import { Form } from 'informed'

export const StyledForm = styled(Form)`
  flex-grow: 1;
  flex-shrink: 0;
`
